<template>
  <div id="Dashboard">
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-row class="pl-4 pt-4 pr-4">
          <van-col span="24">
            <div class="demo-content">
              <h5>{{ getWork().work.WorkName }}</h5>
            </div>
            <p class="text-desc">考试机构上报工作情况汇总</p>
          </van-col>
        </van-row>

        <!-- 时间场次组件 -->
        <time-field @callback="drawStatusList"></time-field>
        
        <!-- 考点工作环节宫格 -->
        <p class="text-desc color-blue">校机构工作环节</p>
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item,index) in AddrStatus"
            :key="index"
            icon="weapp-nav"
            :info="(item.AreaStatusFinished) ? parseInt(item.AreaStatusFinished / item.AreaStatusCount * 100) + '%' : '0'"
            :text="item.StatusName"
            @click="addrStatusScan(item.StatusID)"
          />
        </van-grid>
      </van-pull-refresh>
    </div>

    <!--点击校机构工作环节列表,查看校机构考试工作任务上报情况-->
    <div id="sheet3" v-show="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ AddrStatusList.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet3Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in AddrStatusList.addrlist"
                :key="i"
                class="statusitem text-left m-2"
              >
                <p>
                  <i :class="getWorkStateIcon(e.Status)"></i>
                  <b>{{ e.AddrName }}</b>
                </p>
                <p>
                  <i class="fa fa-tag"></i>
                  上报状态:{{ getWorkStateText(e.Status) }} {{ e.OperationTime }}
                </p>
                <div
                  v-show="e.Status!=1"
                  class="cust-full-right-bottom text-green"
                  @click="setAddrStatusComplete(AddrStatusList,e)"
                >
                  <i class="fa fa-terminal"></i> 设置完成
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"考点工作人员"考试工作任务查看上报情况-->
    <div id="sheet4" v-show="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ AddrStatusList.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet4Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in AddrStatusList.addrlist"
                :key="i"
                class="mui-table-view-cell mui-collapse"
              >
                <a class="mui-navigate-right" href="#">
                  <i :class="getWorkStateIcon(e.Status)"></i>
                  <b>{{ e.AddrName }}</b>
                  <p>工作人员:{{ e.WorkUserNum }}</p>
                </a>
                <div class="mui-collapse-content">
                  <ol>
                    <li v-for="(e_1,i_1) in e.WorkUserList" :key="i_1">
                      {{ e_1.RoleName }} {{ e_1.RealName }} {{ e_1.DutyName }}
                      {{ e_1.Phone }} {{ e_1.Tel }}
                    </li>
                  </ol>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"监考名单上报"考试工作任务查看上报情况-->
    <div id="sheet5" v-show="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ AddrStatusList.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet5Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li v-for="(e,i) in AddrStatusList.addrlist" :key="i" class="text-left m-2">
                <i :class="getWorkStateIcon(e.Status)"></i>
                <b>{{ e.AddrName }}</b>
                <p>
                  上报状态:{{ getWorkStateText(e.Status) }}
                  <small>{{ e.OperationTime }}</small>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"缺考信息上报"考试工作任务查看上报情况-->
    <div id="sheet6" v-show="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ AddrStatusList.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet6Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li v-for="(e,i) in AddrStatusList.addrlist" :key="i" class="text-left m-2">
                <i :class="getWorkStateIcon(e.Status)"></i>
                <b>{{ e.AddrName }}</b>
                <p>
                  上报状态:{{ getWorkStateText(e.Status) }}
                  <small>{{ e.OperationTime }}</small>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeField from "@/components/TimeField.vue";
export default {
  name: "Dashboard",
  data() {
    return {
      isLoading: false,
      ExamTimeList: [], //考试场次列表
      ExamSelect: "",
      AddrStatus: [],
      AddrStatusList: [],
      Msg: ""
    };
  },
  components: {
    timeField
  },
  watch: {},
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast("刷新成功");
        this.isLoading = false;
        this.count++;
      }, 500);
    },
    examSelectChange() {
      this.setExamTime(this.ExamSelect);
      //绘制考务环节列表
      this.drawStatusList();
    },
    drawStatusList() {
      this.apiStatusScanGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime
        },
        this,
        e => {
          //eslint-disable-next-line
          console.log(e); //查看考试工作任务列表
          this.AddrStatus = e.AddrStatus;
          this.Msg = e.ScrollMsg;
          this.getStatusIcon(this.AddrStatus);
        }
      );
    },
    getStatusIcon(statuslist) {
      statuslist.forEach(element => {
        switch (element.StatusID) {
          case "AddrStaff":
            element.icon = "mui-icon mui-icon-contact";
            break;
          case "Monitor":
            element.icon = "mui-icon mui-icon-compose";
            break;
          case "MissExam":
            element.icon = "mui-icon mui-icon-minus";
            break;
        }
      });
    },
    addrStatusScan(statusID) {
      this.apiStatusScanGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime,
          StatusID: statusID
        },
        this,
        e => {
          //eslint-disable-next-line
          console.log(e);
          this.AddrStatusList = e;
          switch (e.StatusID) {
            case "AddrStaff":
              this.$mui("#sheet4").popover("show");
              break;
            case "Monitor":
              this.$mui("#sheet5").popover("show");
              break;
            case "MissExam":
              this.$mui("#sheet6").popover("show");
              break;
            default:
              this.$mui("#sheet3").popover("show");
              break;
          }
        }
      );
    },
    sheet3Prve() {
      this.$mui("#sheet3").popover("hide");
    },
    sheet4Prve() {
      this.$mui("#sheet4").popover("hide");
    },
    sheet5Prve() {
      this.$mui("#sheet5").popover("hide");
    },
    sheet6Prve() {
      this.$mui("#sheet6").popover("hide");
    },
    setAddrStatusComplete(list, item) {
      //eslint-disable-next-line
      console.log(list, item);
      var btnArray = ["取消", "确定"];
      this.$mui.confirm(
        "",
        "确定要设置" + item.AddrName + "的" + list.StatusName + "状态完成?",
        btnArray,
        json => {
          if (json.index == 1) {
            //console.log('确定');
            this.apiStatusReportPost(
              {
                WorkID: this.getWork().work.WorkID,
                BeginTime: this.getExamTime().beginTime,
                RangeID: item.AddrID,
                RoleTypeID: 0,
                StatusJson: JSON.stringify({
                  StatusID: list.StatusID,
                  Status: 1,
                  Statustime: this.getDateTime(),
                  Memo: ""
                }),
                FileList: "",
                AreaSetAddr: true
              },
              this,
              e => {
                //eslint-disable-next-line
                console.log(e);
                if (e.result == "1") {
                  this.$mui.toast("上报完成", { duration: "short" });
                  this.drawStatusList();
                  this.addrStatusScan(list.StatusID);
                } else {
                  this.$mui.alert(
                    e.result.msg,
                    "操作失败",
                    "确定",
                    function() {}
                  );
                }
              }
            );
          } else {
            //eslint-disable-next-line
          }
        },
        "div"
      );
    }
  },
  created() {
    if (this.getExamTime().beginTime) {
      this.ExamTimeList = this.getWork().work.ExamTimeList;
      this.ExamSelect = this.getExamTime().beginTime;
      this.drawStatusList(); //渲染考试工作任务列表
    } else {
      this.$mui.alert("未选择考试场次,无法查看工作情况");
    }
  },
  mounted() {
    this.$mui.init(
      this.$mui(".mui-scroll-wrapper").scroll({
        scrollY: true, //是否竖向滚动
        scrollX: false, //是否横向滚动
        startX: 0, //初始化时滚动至x
        startY: 0, //初始化时滚动至y
        indicators: true, //是否显示滚动条
        deceleration: 0.0006, //阻尼系数,系数越小滑动越灵敏
        bounce: true //是否启用回弹
      })
    );
  }
};
</script>

<style scoped>
.mui-table-view-cell {
  position: relative;
}
.cust-header {
  margin: 0;
}
.cust-header .cust-content {
  font-size: 1rem;
  background: #fff;
  border: 1px solid #eee;
  border-width: 0 1px 0 1px;
  text-indent: 1rem;
  border-radius: 0.4rem 0.4rem 0 0;
}
.cust-card {
  margin: 7px 3px 0 3px;
}
.cust-card .cust-card-header {
  line-height: 2.6rem;
  font-size: 1rem;
  background: #fff;
  border: 1px solid #eee;
  border-width: 0 1px 0 1px;
  text-indent: 1rem;
  border-radius: 0.4rem 0.4rem 0 0;
}
.mui-popover .mui-table-view {
  background: #fff;
}
.mui-table-view.mui-grid-view .mui-table-view-cell {
  background: #fff;
}
.mui-grid-view.mui-grid-9 {
  background: #fff;
}
.mui-table-view.mui-grid-view .mui-table-view-cell .mui-media-body {
  font-size: 12px;
}
.mui-grid-view.mui-grid-9 .mui-table-view-cell {
  padding: 15px 20px 15px 20px;
}
.mui-col-xs-4 {
  height: 5.5rem;
}
progress {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  border: none;
  background: rgb(162, 255, 204);
}
progress::-moz-progress-bar {
  background: rgb(162, 255, 204);
}
progress::-webkit-progress-bar {
  background: #fff;
}
progress::-webkit-progress-value {
  background: rgb(168, 255, 186);
}
select {
  width: 100%;
  padding-right: 0;
  font-weight: bold;
  text-align: center;
}
.mui-grid-view.mui-grid-9 .mui-media .mui-icon {
  font-size: 2.1em;
}
.mui-icon .mui-badge {
  background: #f0ad4e;
  color: #fff;
}
.statusitem {
  padding: 10px;
  border: 1px solid #979797;
  border-radius: 10px;
  box-shadow: 3px 3px 3px #c7c7c7;
}
</style>